<div class="customer-area-menu flex flex-col min-h-full bg-transparent md:h-auto">
  <div class="px-6 pt-5 pb-2">
    <div class="flex items-center justify-between mb-3">
      <div class="w-1/2 cursor-pointer" (click)="clickOnLogo()">
        <app-logo [premium]="premiumCustomer()" [color]="(premiumCustomer() || themeService.isDarkMode()) ? 'light' : 'primary'"></app-logo>
      </div>
      <app-show-amounts *ngIf="isSelectedPortfolioEnabled()"></app-show-amounts>
    </div>
    <div *ngIf="hasCustomerOperationalBlockReasons()" class="flex items-center gap-3">
      <ion-icon class="text-3xl text-on-surface-variant" name="person-circle-outline"></ion-icon>
      <p class="text-sm font-semibold text-on-background">{{ loggedUser?.userData?.name }}</p>
    </div>
    <div class="relative profile-dropdown-container">
      <div
        *ngIf="!hasCustomerOperationalBlockReasons()"
        (click)="toggleProfileDropdown($event)"
        data-test="myProfile"
        class="flex items-center justify-between gap-3 px-3 py-3 rounded-xl hover:bg-surface-container-low transition-colors cursor-pointer select-none">
        
        <div class="flex items-center gap-3">
          <div class="w-9 h-9 rounded-full bg-surface-container border border-outline-variant text-on-background flex items-center justify-center text-sm font-bold">
            {{ getUserInitials() }}
          </div>
          <div class="flex flex-col">
            <p class="text-sm font-bold text-on-background">{{ loggedUser?.userData?.name }}</p>
          </div>
        </div>
        
        <ion-icon
          [name]="profileDropdownOpen ? 'chevron-up-outline' : 'chevron-down-outline'"
          class="text-on-surface-variant text-sm pr-1">
        </ion-icon>
      </div>

      <div *ngIf="profileDropdownOpen && !hasCustomerOperationalBlockReasons()"
           class="absolute left-3 right-3 top-[52px] bg-surface-container-lowest border border-outline-variant rounded-xl z-50 p-2 flex flex-col gap-0.5 mt-1">
        
        <app-menu-item route="/client/profile/personal-data" typeOfUrlMatchToActiveItem="full" data-test="personalData">
          <ion-icon icon name="person-outline"></ion-icon>
          <p text>{{ 'menu.personalData' | translate }}</p>
        </app-menu-item>
        
        <app-menu-item *ngIf="!doPartnerProvidesUserData()" route="/client/profile/configuration">
          <ion-icon icon name="settings-outline"></ion-icon>
          <p text>{{ 'menu.appConfiguration' | translate }}</p>
        </app-menu-item>

        <app-menu-item route="/client/help">
          <ion-icon icon name="help-circle-outline"></ion-icon>
          <p text>{{ 'menu.help' | translate }}</p>
        </app-menu-item>

        <app-menu-item route="/client/profile/documents">
          <ion-icon icon name="document-text-outline"></ion-icon>
          <p text>{{ 'menu.fiscalReports' | translate }}</p>
        </app-menu-item>

        <app-menu-item (click)="toggleTheme($event)">
          <ion-icon icon [name]="themeService.isDarkMode() ? 'sunny-outline' : 'moon-outline'"></ion-icon>
          <p text>{{ (themeService.isDarkMode() ? 'menu.lightMode' : 'menu.darkMode') | translate }}</p>
        </app-menu-item>
      </div>
    </div>

  </div>

  <div class="flex-1 px-4 md:overflow-visible">
    <div class="flex flex-col w-full pt-1 pb-0 empty:hidden">
      <app-menu-item *ngIf="!hasCustomerOperationalBlockReasons()" route="/client/plan/create">
        <ion-icon icon name="add-circle-outline"></ion-icon>
        <p text>{{ 'menu.newPlan' | translate }}</p>
      </app-menu-item>

      <app-menu-item *ngIf="!hasCustomerOperationalBlockReasons()" [route]="allPortfoliosUrl()">
        <ion-icon icon name="albums-outline"></ion-icon>
        <p text>{{ 'menu.allMyProducts' | translate }}</p>
      </app-menu-item>

      <div *ngIf="selectedPortfolio && !hasCustomerOperationalBlockReasons() && !isNewProductScreen()"
           class="flex flex-col p-3 border border-outline-variant bg-surface-container-lowest rounded-card select-none">
        <p class="text-3xs uppercase tracking-wider font-extrabold text-primary mb-1">
          {{ 'menu.productSelected' | translate }}
        </p>
        
        <h4 class="flex items-center gap-2.5 text-sm text-on-background">
          <ng-container *ngIf="selectedBoPortfolio?.investmentStrategy">
            <ion-icon *ngIf="isStrategyLogoAsset(); else strategyLogoName"
                      [src]="getStrategyLogo()"
                      class="shrink-0 text-base leading-none text-primary"></ion-icon>
            <ng-template #strategyLogoName>
              <ion-icon [name]="getStrategyLogo()" class="shrink-0 text-base leading-none text-primary"></ion-icon>
            </ng-template>
          </ng-container>
          <span class="line-clamp-1">{{ selectedPortfolio.title }}</span>
        </h4>
        
        <p *ngIf="selectedBoPortfolio" class="text-xs text-on-surface-variant font-medium line-clamp-1 mt-0">
          {{ selectedBoPortfolio.externalTolerance }} - {{ selectedBoPortfolio.title }}
        </p>
      </div>
    </div>

    <div *ngIf="!isNewProductScreen()" class="flex flex-col w-full pb-1 empty:hidden">
      <p class="text-xs font-extrabold text-on-surface-variant uppercase tracking-[0.12em] mt-3 mb-0.5 px-3">{{ 'menu.sectionConsulta' | translate }}</p>
      <app-menu-item [route]="resumeUrl" typeOfUrlMatchToActiveItem="full">
        <ion-icon icon name="timer-outline"></ion-icon>
        <p text>{{ 'menu.resume' | translate }}</p>
      </app-menu-item>
      <app-menu-item route="/client/last-movements">
        <ion-icon icon name="list-outline"></ion-icon>
        <p text>{{ 'shared.movements' | translate | titlecase }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="isSelectedPortfolioEnabled()" route="/client/portfolio/progress">
        <ion-icon icon name="pulse-outline"></ion-icon>
        <p text>{{ 'menu.portfolioProgress' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="isSelectedPortfolioEnabled() && !hasCustomerOperationalBlockReasons()" route="/client/simulator/menu">
        <ion-icon icon name="calculator-outline"></ion-icon>
        <p text>{{ 'menu.investmentSimulator' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="shouldShowFeesMenuButton() && !hasCustomerOperationalBlockReasons()" route="{{redirectRouteFeesPage()}}">
        <ion-icon icon name="logo-euro"></ion-icon>
        <p text>{{ 'shared.fees' | translate }}</p>
      </app-menu-item>

      <app-menu-item *ngIf="canShowPortfolioConfigurationButton() && !hasCustomerOperationalBlockReasons()" route="/client/portfolio-configuration/documents">
        <ion-icon icon name="document-text-outline"></ion-icon>
        <p text>{{ 'menu.productDocumentation' | translate }}</p>
      </app-menu-item>
    </div>

    <div *ngIf="!isNewProductScreen()" class="flex flex-col w-full pb-1 empty:hidden">
      <p class="text-xs font-extrabold text-on-surface-variant uppercase tracking-[0.12em] mt-3 mb-0.5 px-3">{{ 'menu.sectionOperativa' | translate }}</p>
      <ng-container *ngIf="canShowContributionsGroup()">
        <app-menu-item *ngIf="canShowRegularCashTransferIn()" [route]="regularCashTransferInUrl()">
          <ion-icon icon name="bar-chart-outline"></ion-icon>
          <p text>{{ 'menu.regularMonetaryContribution' | translate }}</p>
        </app-menu-item>
        <app-menu-item *ngIf="canShowExtraordinaryCashTransferIn()" [route]="extraordinaryCashTransferInUrl()">
          <ion-icon icon name="paper-plane-outline"></ion-icon>
          <p text>{{ 'menu.extraordinaryMonetaryContribution' | translate }}</p>
        </app-menu-item>
      </ng-container>
      <app-menu-item *ngIf="canShowDeposit() && !hasCustomerOperationalBlockReasons()" [route]="depositUrl()">
        <ion-icon icon name="paper-plane-outline"></ion-icon>
        <p text>{{ 'menu.deposit' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="canShowInvestmentTransferFundsButton() && !hasCustomerOperationalBlockReasons()" route="{{ investmentTransferFundsUrl() }}">
        <ion-icon icon name="shuffle-outline"></ion-icon>
        <p text>{{ 'menu.transferFunds' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="canShowPensionPlanTransferButton() && !hasCustomerOperationalBlockReasons()" route="/client/pension-plan/transfer">
        <ion-icon icon name="shuffle-outline"></ion-icon>
        <p text>{{ 'menu.transferPlan' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="canShowWithdrawal() && !hasCustomerOperationalBlockReasons()" route="/client/withdrawal">
        <ion-icon icon name="download-outline"></ion-icon>
        <p text>{{ 'menu.withdrawal' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="canShowPortfolioConfigurationButton() && !hasCustomerOperationalBlockReasons()" route="/client/portfolio-configuration/data">
        <ion-icon icon name="settings-outline"></ion-icon>
        <p text>{{ 'menu.planConfiguration' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="canShowPremiumButton() && !hasCustomerOperationalBlockReasons()" (click)="showPremiumModal()">
        <ion-icon icon name="arrow-up-outline" class="text-premium"></ion-icon>
        <p text>{{ 'menu.upgradePremium' | translate }}</p>
      </app-menu-item>
    </div>

    <div *ngIf="!isNewProductScreen() && canShowRecommendUsButton() && !hasCustomerOperationalBlockReasons()" class="flex flex-col w-full pb-1">
      <p class="text-xs font-extrabold text-on-surface-variant uppercase tracking-[0.12em] mt-3 mb-0.5 px-3">{{ 'menu.sectionPlanAmigo' | translate }}</p>
      
      <app-menu-item *ngIf="isRecommendUsButtonOfTypeFriendPlan()" route="/client/invite">
        <ion-icon icon name="person-add-outline" class="text-primary"></ion-icon>
        <p text class="text-primary">
          {{ 'menu.friendPlanWithoutFees' | translate:{money: amountWithoutFees() | money:0} }}
        </p>
      </app-menu-item>
      
      <app-menu-item *ngIf="!isRecommendUsButtonOfTypeFriendPlan()" route="/client/invite">
        <ion-icon icon name="share-social-outline" class="text-primary"></ion-icon>
        <p text class="text-primary">
          {{ 'menu.recommendUs' | translate }}
        </p>
      </app-menu-item>
    </div>
  </div>

  <div class="px-4 py-3 mt-auto">
    <div class="border-t border-outline-variant mb-3"></div>
    <div *ngIf="showPoweredBy()" class="flex justify-end mb-3">
      <app-powered-by></app-powered-by>
    </div>
    <app-share-screen *ngIf="shouldShowLink()" size="sm">
      <app-link color="dark" class="ml-5">{{ 'onboarding.footer.shareScreen.link' | translate }}</app-link>
    </app-share-screen>
    <div class="flex flex-wrap justify-between w-full">
      <app-menu-item class="mr-2" route="/client/help">
        <ion-icon icon name="help-circle-outline"></ion-icon>
        <p text>{{ 'menu.help' | translate }}</p>
      </app-menu-item>
      <app-menu-item *ngIf="shouldShowButtonLogout()" route="/client/logout">
        <ion-icon icon name="close-circle-outline"></ion-icon>
        <p text>{{ 'menu.logout' | translate }}</p>
      </app-menu-item>
    </div>
  </div>
</div>
